<script>
import { sanitizeUrl } from '@braintree/sanitize-url';
import { assetURL, baseURL } from '../../utils/url';

export default {
    data() {
        return {
            banner: `${assetURL}images/location-banner.png`,
            items: [],
            imageRefs: [],
            spinnerRefs: [],
        };
    },
    methods: {
        getLocations() {
            axios.get('/locations/getLocations').then((response) => {
                this.items = response.data.locations;

                this.$nextTick(() => {
                    // After DOM update
                    this.lazyLoadImages();
                });
            });
        },
        sanitize(url) {
            return sanitizeUrl(url);
        },
        lazyLoadImages() {
            this.imageRefs.forEach((img, i) => {
                const realSrc = img.dataset.src;

                const tempImg = new Image();
                tempImg.onload = () => {
                    img.src = realSrc;
                    this.spinnerRefs[i]?.classList.add('hide-spinner');
                };
                tempImg.onerror = () => {
                    // Optionally handle image loading error
                    this.spinnerRefs[i]?.classList.add('hide-spinner');
                };
                tempImg.src = realSrc;
            });
        },
    },
    beforeMount() {
        this.getLocations();
    },
    mounted() {
        this.getLocations();
    },
};
</script>
<template>
    <div
        class="tw-w-full md:tw-w-[calc(100%_-_300px)] md:tw-ml-[calc(8rem_*_calc(1_-_0))] tw-mr-0 md:-tw-mr-[50px] lg:tw-mr-0 xxl:tw-mr-[-90px] tw-relative"
    >
        <div
            class="tw-relative tw-top-[50px] tw-left-[65px] md:-tw-left-[50px] -md:tw-pr-[50px] lg:tw-pr-[25px] md:-tw-mt-[50px] tw-w-[80%] md:tw-w-[-webkit-fill-available]"
            style="border: 2px solid #cacda5; height: calc(100% - 25px)"
        >
            <div
                class="tw-flex tw-flex-wrap tw-mt-[50px] -tw-ml-[50px] tw-h-full"
            >
                <a
                    :href="this.sanitize(location.url)"
                    class="tw-contents tw-text-[inherit] hover:tw-text-[inherit] tw-no-underline"
                    v-for="(location, index)  in items"
                >
                    <div
                        class="tw-w-full md:tw-w-1/2 xxl:tw-w-1/3 tw-h-auto tw-pr-8 md:tw-px-4 tw-mb-5"
                    >
                        <div class="tw-h-[341px] xxl:tw-h-[400px]">
                            <div class="lazyload image-wrapper tw-h-[400px]">
                                <img
                                    :data-src="location.thumbnail_image"
                                    :ref="el => imageRefs[index] = el"
                                    class="swiper-lazy tw-w-full tw-object-cover tw-object-center tw-h-[-webkit-fill-available]"
                                />
                                <div class="manual-spinner" :ref="el => spinnerRefs[index] = el"></div>
                            </div>
                        </div>
                        <div
                            class="tw-h-[139pt] tw-bg-grey1 tw-p-3 lg:tw-p-9 lg:tw-h-auto"
                        >
                            <h2 class="tw-text-4xl tw-mb-8 tw-font-bold fs-25px-md
                            md:tw-leading-none
                            md:tw-h-[50px]
                            mb-10px-lg
                            fs-24px-xl
                            xxl:tw-h-[40px]
                            ">
                                {{ location.name }}
                            </h2>
                            <div class="lg:tw-space-x-2">
                                <a class="mx-0" href="/estates">
                                    <button
                                        class="tw-text-darkGreen tw-text-[14px] tw-px-[10px] tw-py-[3px] tw-uppercase
                                        mb-10px-md
                                        mb-0px-xl mr-10px-xl"
                                        style="border: 1px solid #4a5846"
                                    >
                                        Estate
                                    </button>
                                </a>
                                <a class="mx-0" href="/properties">
                                    <button
                                        class="tw-text-darkGreen tw-text-[14px] tw-px-[10px] tw-py-[3px] tw-uppercase"
                                        style="border: 1px solid #4a5846"
                                    >
                                        Properties
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>
